import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import SnackbarMessage from "../../../../components/snackBar/snackBar.jsx";
import { useNavigate } from "react-router-dom";
import ELK from "elkjs/lib/elk.bundled.js";
import ReactFlow, {
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  Controls,
  MarkerType,
  ReactFlowProvider,
  Panel,
  useReactFlow,
  Background,
  BackgroundVariant,
} from "reactflow";
import "reactflow/dist/style.css";
import "./nodes/custom.css";
import Custom from "./nodes/custom.js";
import Custom2 from "./nodes/custom2.js";
import Custom3 from "./nodes/custom3.js";
import Custom4 from "./nodes/custom4.js";
import ButtonEdge from "./edges/customEdge";
import {
  Dialog,
  CircularProgress,
  Typography,
  DialogContent,
  Box,
  Button,
  Stack,
  Avatar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import KeyIcon from "@mui/icons-material/Key";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { QR, QrActionButton, qrDialogPaperSx, QrModalHeader } from "../../../qrCode/components/qrUi";
import Slide from "@mui/material/Slide";
import AddIcon from "@mui/icons-material/Add";
import { useSelector, useDispatch } from "react-redux";
import {
  createChatBotThunk,
  editChatBotThunk,
  getChatBotThunk,
} from "../../chatBotThunk.js";
import { APP_ROUTES } from "../../../../config/appRoutes.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
// Set the app element for accessibility
// Dialog.setAppElement("#root");
// Suppress ResizeObserver loop error - this is a harmless browser warning
const resizeObserverErrorHandler = (e) => {
  const errorMessage = e.message || e.error?.message || "";
  if (
    errorMessage.includes(
      "ResizeObserver loop completed with undelivered notifications"
    )
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  return true;
};

// Add error handler early to catch all ResizeObserver errors
// Use capture phase to catch errors before they bubble
if (typeof window !== "undefined") {
  window.addEventListener("error", resizeObserverErrorHandler, true);

  // Also handle unhandled promise rejections that might contain this error
  window.addEventListener("unhandledrejection", (e) => {
    const errorMessage = e.reason?.message || String(e.reason || "");
    if (
      errorMessage.includes(
        "ResizeObserver loop completed with undelivered notifications"
      )
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}
const elk = new ELK();

const elkOptions = {
  "elk.algorithm": "layered",
  "elk.layered.spacing.nodeNodeBetweenLayers": "100",
  "elk.spacing.nodeNode": "80",
};

const getLayoutedElements = (nodes, edges, options = {}) => {
  const isHorizontal = options?.["elk.direction"] === "RIGHT";
  const graph = {
    id: "root",
    layoutOptions: options,
    children: nodes.map((node) => ({
      ...node,
      targetPosition: isHorizontal ? "left" : "top",
      sourcePosition: isHorizontal ? "right" : "bottom",
      width: 100,
      height: 50,
    })),
    edges: edges,
  };

  return elk
    .layout(graph)
    .then((layoutedGraph) => ({
      nodes: layoutedGraph.children.map((node) => ({
        ...node,
        position: { x: node.x, y: node.y },
      })),
      edges: layoutedGraph.edges,
    }))
    .catch(console.error);
};

const nodeTypes = {
  customNode1: Custom,
  customNode2: Custom2,
  customNode3: Custom3,
  customNode4: Custom4,
};

const edgeTypes = {
  buttonedge: ButtonEdge,
};

const rfStyle = {
  backgroundColor: "#f8fafc",
};

const initialNodes = [
  {
    id: `${String(+new Date()).slice(6)}`,
    type: "customNode1",
    data: { label: "Trigger Node" },
    position: { x: 0, y: 0 },
  },
  // {
  //   id: `${String(+new Date()).slice(7)}`,
  //   type: "customNode2",
  //   data: { label: "Buttons Node" },
  //   position: { x: 190, y: 0 },
  // },
  // {
  //   id: `${String(+new Date()).slice(5)}`,
  //   type: "customNode3",
  //   data: { label: "List Node" },
  //   position: { x: 190, y: 0 },
  // },
];

const initialEdges = [
  // {
  //   id: "edge-1",
  //   source: `${String(+new Date()).slice(6)}`,
  //   target: `${String(+new Date()).slice(7)}`,
  //   type: "buttonedge",
  //   markerEnd: { type: MarkerType.ArrowClosed },
  // },
];

const Flow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { chatBotCreationDetails, status, error } = useSelector(
    (state) => state.chatBot
  );

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [onChangeLoader, setOnChangeLoader] = useState(0);
  const keyWordName = chatBotCreationDetails[0]?.chatBotKey;
  const chatBotName = chatBotCreationDetails[0]?.chatBotName;
  const id = chatBotCreationDetails[0]?.id;

  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);

  // Note: ResizeObserver error handler is registered globally at module level
  // and should not be removed as it's needed for the entire app lifecycle
  const [showModal, setShowModal] = useState(false);
  const [leaveOpen, setLeaveOpen] = useState(false); // Back button confirmation
  const [chatbotEdges, setChatBotEdges] = useState(false);
  const [sourceNodeId, setSourceNodeId] = useState(null);
  const [targetNodeId, setTargetNodeId] = useState(null);

  const handleEdgeStart = (event, sourceNode) => {
    setSourceNodeId(sourceNode.id);
  };

  useEffect(() => {
    return () => {
      // This code will run when the component is unmounted
      sessionStorage.removeItem("chatbotResponse");
    };
  }, []);

  const handleEdgeEnd = (event, targetNode) => {
    setShowModal(true);
  };

  useEffect(() => {
    setTimeout(() => {
      if (chatbotEdges === true && edges.length > 0 && id !== undefined) {
        onLogData();
        setChatBotEdges(false);
      }
    }, 2000);
  }, [chatbotEdges]);

  useEffect(() => {
    setTimeout(() => {
      if (
        chatBotCreationDetails &&
        chatBotCreationDetails[0]?.chat_bot_nodes &&
        chatBotCreationDetails[0]?.chat_bot_edges
      ) {
        setNodes(chatBotCreationDetails[0]?.chat_bot_nodes);
        setEdges(chatBotCreationDetails[0]?.chat_bot_edges);
      }
    }, 1000);
  }, [chatBotCreationDetails]);

  const handleNodeTypeSelect = (selectedNodeType) => {
    setShowModal(false);

    const newTargetNode = {
      id: Date.now().toString(),
      type: selectedNodeType,
      position: { x: 200, y: 200 },
    };

    setNodes((prevNodes) => [...prevNodes, newTargetNode]);

    if (sourceNodeId !== undefined && targetNodeId !== undefined) {
      setEdges((prevEdges) => [
        ...prevEdges,
        {
          id: `edge-${sourceNodeId}-${targetNodeId}`,
          source: sourceNodeId,
          target: newTargetNode.id,
        },
      ]);
    }

    setSourceNodeId(null);
    setTargetNodeId(null);
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setSourceNodeId(null);
    setTargetNodeId(null);
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes]
  );

  const onEdgesChange = useCallback(
    (changes) => {
      setEdges((eds) => applyEdgeChanges(changes, eds));
      if (id) {
        setChatBotEdges(true);
      }
    },
    [setEdges]
  );

  const connectionCreated = useRef(false);

  const onConnect = useCallback(
    (connection) => {
      connectionCreated.current = true;
      setShowModal(false);

      setEdges((eds) =>
        addEdge(
          {
            ...connection,
            type: "buttonedge",
            markerEnd: { type: MarkerType.ArrowClosed },
            data: { setEdges },
          },
          eds
        )
      );
      setChatBotEdges(true);
    },
    [setEdges, setShowModal]
  );

  const onConnectEnd = useCallback(() => {
    // if no connection was created, show an alert (or in your case a modal)
    if (!connectionCreated.current) {
      //alert("Connection was dropped but no connection was created.");
      setShowModal(true);
    }
    // reset the flag
    connectionCreated.current = false;
  }, [connectionCreated]);

  const proOptions = { hideAttribution: true };

  const { fitView } = useReactFlow();

  const onLayout = useCallback(
    ({ direction, useInitialNodes = false }) => {
      const opts = { "elk.direction": direction, ...elkOptions };
      const ns = useInitialNodes ? initialNodes : nodes ? nodes : " ";
      const es = useInitialNodes ? initialEdges : edges;

      getLayoutedElements(ns, es, opts).then(
        ({ nodes: layoutedNodes, edges: layoutedEdges }) => {
          setNodes(layoutedNodes);
          setEdges(layoutedEdges);

          window.requestAnimationFrame(() => fitView());
        }
      );
    },
    [nodes, edges]
  );

  useEffect(() => {
    if (nodes.length > 0) {
      fitView();
    }
  }, [nodes]);
  useLayoutEffect(() => {
    onLayout({ direction: "RIGHT", useInitialNodes: true });
  }, []);

  const chatbotCreation = async (botData, value) => {
    try {
      let result;

      const payload = {
        credentials: {
          chat_bot_name: chatBotName,
          chat_bot_flow: botData,
          key_words: keyWordName,
          chat_bot_nodes: nodes,
          chat_bot_edges: edges,
        },
      };

      if (
        chatBotCreationDetails &&
        chatBotCreationDetails[0]?.id !== undefined
      ) {
        payload.credentials.chat_bot_id = chatBotCreationDetails[0]?.id || id;
        result = await dispatch(editChatBotThunk(payload));
      } else {
        result = await dispatch(createChatBotThunk(payload));
      }

      if (result.meta.requestStatus === "fulfilled") {
        setSnackbar({
          open: true,
          message: result.payload.message,
          severity: "success",
        });
        dispatch(getChatBotThunk({ type: "getBot" }));

        // Only navigate to list if it's a creation, not an update
        if (
          !(chatBotCreationDetails && chatBotCreationDetails[0]?.id !== null) ||
          value === "submitted"
        ) {
          navigate(APP_ROUTES.CHATBOT.LIST);
        }
      } else {
        setSnackbar({
          open: true,
          message: result.payload || "Something went wrong",
          severity: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    }
  };

  const onLogData = (value) => {
    if (nodes.length > 1 && edges.length > 0) {
      const groupedEdges = edges.reduce((acc, edge) => {
        const { source } = edge;
        if (!source) return acc;

        if (!acc[source]) {
          acc[source] = [];
        }
        acc[source].push(edge);

        return acc;
      }, {});

      const groupedEdgesArray = Object.entries(groupedEdges).map(
        ([source, edges]) => ({
          source,
          edges,
        })
      );

      const Edges = groupedEdgesArray;

      const idsAndData = nodes.map((node) => ({
        id: node.id,
        data: node.data,
      }));

      const extractedData = Edges.map((item) => ({
        source: item.source,
        edges: item.edges.map((edge) => ({
          id: edge.id,
          target: edge.target,
          source: edge.source,
        })),
      }));

      const chatBot = [];

      const noEdgebuttonsData = (nobuttons) => {
        let action = {};
        if (nobuttons.data && nobuttons.data.state) {
          if (
            nobuttons.data.state.buttons &&
            nobuttons.data.state.buttons.length > 0
          ) {
            action = {
              buttons: nobuttons.data.state.buttons.map((button) => ({
                type: "reply",
                reply: {
                  id: button.id.toString(), // Assign the correct button ID
                  title: button.value,
                },
              })),
            };
          } else if (
            nobuttons.data.state.list &&
            nobuttons.data.state.list.length > 0
          ) {
            action = {
              button: nobuttons.data.state.listButton,
              sections: [
                {
                  rows: nobuttons.data.state.list.map((item) => ({
                    id: item.id.toString(), // Assign the correct list item ID
                    title: item.value,
                  })),
                },
              ],
            };
          }
        }
        return action;
      };

      const headerFunction = (node) => {
        if (node.data && node.data.state && node.data.state.url) {
          const url = node.data.state.url;
          if (
            url &&
            url?.file_extension_type &&
            url.file_extension_type.includes("image")
          ) {
            return {
              type: "image",
              image: {
                link: url.file_url,
              },
            };
          } else if (
            url &&
            url?.file_extension_type &&
            url.file_extension_type.includes("pdf")
          ) {
            return {
              type: "document",
              document: {
                link: url.file_url,
              },
            };
          } else if (
            url &&
            url?.file_extension_type &&
            url.file_extension_type.includes("video")
          ) {
            return {
              type: "video",
              video: {
                link: url.file_url,
              },
            };
          }
        }
        return {
          type: "text",
          text:
            (node && node.data && node.data.header) ||
            (node && node.data && node.data.state && node.data.state.header) ||
            "N/A",
        };
      };

      const buttonsData = (node, edges) => {
        let action = {};
        if (node.data && edges) {
          if (node.data.state.list && node.data.state.list.length > 0) {
            // debugger;
            action = {
              button: node.data.state.listButton,
              sections: [
                {
                  rows: edges.map((edge, index) => ({
                    id: edge.target === nodes[0].id ? keyWordName : edge.target,
                    // title: node.data.state.list[index].value,
                    title: node?.data?.state?.list?.[index]?.value || "N/A",
                  })),
                },
              ],
            };
          } else if (
            node.data.state.buttons &&
            node.data.state.buttons.length > 0
          ) {
            action = {
              buttons: node.data.state.buttons.map((button, index) => ({
                type: "reply",
                reply: {
                  id:
                    edges[index] && edges[index].target !== undefined
                      ? edges[index].target === nodes[0].id
                        ? keyWordName
                        : edges[index].target
                      : "N/A",
                  title: button && button.value,
                },
              })),
            };
          }
        }
        return action;
      };

      idsAndData.forEach((node, index) => {
        const nodeId = node.id;
        const nodeEdges = extractedData.find((item) => item.source === nodeId);
        const edgeId = nodeEdges?.source;
        const header = headerFunction(node);

        if (nodeId === edgeId) {
          const action = buttonsData(node, nodeEdges.edges);
          chatBot.push({
            keys: index === 0 ? keyWordName : nodeId,
            type:
              node.data?.state.buttons?.length > 0
                ? "interactive"
                : node.data?.state.list?.length > 0
                ? "interactive"
                : "final",
            messages: {
              body: {
                text: node.data?.message || node.data?.state.message || "",
              },
              type:
                node.data?.state.buttons?.length > 0
                  ? "button"
                  : node.data?.state.list?.length > 0
                  ? "list"
                  : "final",
              ...(node.data?.state.buttons?.length > 0 ||
              node.data?.state.list?.length > 0
                ? { action: action }
                : {}),
              ...(node.data?.state.url || node.data?.state.header
                ? { header: header }
                : {}),
            },
          });
        } else {
          const noedgeAction = noEdgebuttonsData(node);
          chatBot.push({
            keys: nodeId,
            // type:
            //   node.data?.state.buttons?.length > 0
            //     ? "interactive"
            //     : node.data?.state.list?.length > 0
            //       ? "interactive"
            //       : "final",

            type:
              node?.data?.state?.buttons?.length > 0 ||
              node?.data?.state?.list?.length > 0
                ? "interactive"
                : "final",

            messages: {
              body: {
                text: node?.data?.message || node?.data?.state?.message || "",
              },
              type:
                node?.data?.state?.buttons?.length > 0
                  ? "button"
                  : node?.data?.state?.list?.length > 0
                  ? "list"
                  : "final",

              ...(node?.data?.state?.buttons?.length > 0 ||
              node?.data?.state?.list?.length > 0
                ? { action: noedgeAction }
                : {}),

              ...(node?.data?.state?.url || node?.data?.state?.header
                ? { header }
                : {}),
            },
          });
        }
      });

      if (chatBot.length > 0) {
        const newData = chatBot
          .map((item) => {
            const messages = item.messages;
            const newMessages = {};
            Object.keys(messages).forEach((key) => {
              if (messages[key] !== "") {
                newMessages[key] = messages[key];
              }
            });
            return {
              ...item,
              messages: newMessages,
            };
          })
          .filter((item) => Object.keys(item.messages).length > 0);
        chatbotCreation(newData, value);
      }
    }
  };

  // Layout types offered in the "Add Layout" popup (display only)
  const layoutOptions = [
    { type: "customNode2", label: "Buttons", text: "A message with quick reply buttons", icon: <SmartButtonIcon />, color: "#2563eb" },
    { type: "customNode3", label: "List", text: "A message with a menu list of options", icon: <FormatListBulletedIcon />, color: "#7c3aed" },
    { type: "customNode4", label: "Final", text: "A closing message that ends the flow", icon: <FlagOutlinedIcon />, color: "#16a34a" },
  ];

  return (
    <div>
      {onChangeLoader === 1 ? (
        <Box
          sx={{
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <CircularProgress size={44} sx={{ color: QR.main }} />
          <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#64748b" }}>Loading bot flow...</Typography>
        </Box>
      ) : (
        <Stack spacing={1.5}>
          {/* ---------- Top bar: back, bot info, actions ---------- */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.5,
              p: { xs: 1.5, sm: 2 },
              borderRadius: 3,
              border: `1px solid ${QR.border}`,
              bgcolor: "#fff",
              boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0 }}>
              <Box sx={{ flexShrink: 0, "& .MuiButton-root": { height: 40, px: { xs: 1.25, sm: 1.75 } } }}>
                <QrActionButton
                  variant="solid"
                  color="#fc8006" // logo orange
                  gradientTo="#fb923c"
                  icon={<ArrowBackIcon sx={{ fontSize: 17 }} />}
                  label="Back to List"
                  onClick={() => setLeaveOpen(true)}
                />
              </Box>
              <Avatar
                variant="rounded"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: 2.5,
                  color: "#fff",
                  background: `linear-gradient(135deg, ${QR.main}, ${QR.light})`,
                  boxShadow: `0 8px 18px -8px ${QR.main}`,
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <SmartToyIcon />
              </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography noWrap sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, color: "#0f172a", lineHeight: 1.25 }}>
                  {chatBotName || "Chat Bot"}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mt: 0.25 }}>
                  {keyWordName && (
                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.4, maxWidth: "100%", wordBreak: "break-all", px: 0.9, py: 0.15, borderRadius: 1.5, fontFamily: "monospace", fontSize: 12, fontWeight: 700, color: QR.purple, bgcolor: `${QR.purple}12`, border: `1px solid ${QR.purple}26` }}>
                      <KeyIcon sx={{ fontSize: 12 }} />
                      {keyWordName}
                    </Box>
                  )}
                  <Box component="span" sx={{ px: 0.9, py: 0.15, borderRadius: 1.5, fontSize: 11.5, fontWeight: 700, color: id ? QR.amber : QR.main, bgcolor: id ? `${QR.amber}14` : `${QR.main}14` }}>
                    {id ? "Editing" : "New bot"}
                  </Box>
                </Stack>
              </Box>
            </Stack>

            <Stack direction="row" spacing={1} sx={{ width: { xs: "100%", sm: "auto" }, "& > *": { flex: { xs: 1, sm: "0 0 auto" } }, "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } } }}>
              <Box>
                <QrActionButton
                  icon={<AddIcon sx={{ fontSize: 18 }} />}
                  label="Add Layout"
                  color={QR.blue}
                  onClick={() => setShowModal(true)}
                />
              </Box>
              <Box>
                <QrActionButton
                  variant="solid"
                  color={QR.blue}
                  gradientTo="#3b82f6"
                  icon={<SendRoundedIcon sx={{ fontSize: 17 }} />}
                  label="Submit"
                  loading={status === "loading"}
                  loadingLabel="Submitting..."
                  onClick={() => onLogData("submitted")}
                />
              </Box>
            </Stack>
          </Box>

          {/* ---------- Canvas ---------- */}
          <Box
            className="bot-flow-canvas"
            sx={{
              position: "relative",
              height: { xs: "calc(100vh - 250px)", sm: "calc(100vh - 190px)" },
              minHeight: 460,
              borderRadius: 3,
              overflow: "hidden",
              border: `1px solid ${QR.border}`,
              boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
            }}
          >
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onConnectEnd={onConnectEnd}
              proOptions={proOptions}
              nodeTypes={nodeTypes}
              edgeTypes={edgeTypes}
              onConnectStart={handleEdgeStart}
              onInit={(instance) => instance.fitView()}
              style={rfStyle}
            >
              <Background variant={BackgroundVariant.Dots} gap={18} size={1.4} color="#cbd5e1" />
              <Controls showInteractive={true} position="bottom-right" />

              <Panel position="top-left">
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={0.75}
                  sx={{ px: 1.25, py: 0.6, borderRadius: 5, bgcolor: "rgba(255,255,255,0.92)", border: `1px solid ${QR.border}`, boxShadow: "0 1px 3px rgba(16,24,40,0.08)" }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 15, color: QR.blue }} />
                  <Typography sx={{ fontSize: 12, color: "#475569", display: { xs: "none", sm: "block" } }}>
                    Drag from a node's dot to another node to connect steps
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "#475569", display: { xs: "block", sm: "none" } }}>
                    Drag dots to connect
                  </Typography>
                </Stack>
              </Panel>
            </ReactFlow>
          </Box>

          {/* ---------- Add Layout popup ---------- */}
          <Dialog
            open={showModal}
            onClose={handleModalCancel}
            fullWidth
            disableEscapeKeyDown
            aria-labelledby="custom-dialog"
            TransitionComponent={Transition}
            maxWidth="xs"
            keepMounted
            PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 440 } } }}
          >
            <QrModalHeader
              icon={<AddIcon />}
              title="Add Layout"
              subtitle="Choose the type of step to add to the flow"
              onClose={handleModalCancel}
            />
            <DialogContent sx={{ p: { xs: 1.5, sm: 2 } }}>
              <Stack spacing={1.25}>
                {layoutOptions.map((o) => (
                  <Box
                    key={o.type}
                    component="button"
                    type="button"
                    onClick={() => handleNodeTypeSelect(o.type)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      width: "100%",
                      p: 1.5,
                      textAlign: "left",
                      cursor: "pointer",
                      font: "inherit",
                      borderRadius: 2.5,
                      bgcolor: "#fff",
                      border: `1.5px solid ${QR.border}`,
                      transition: "all .15s ease",
                      "&:hover": { borderColor: o.color, bgcolor: `${o.color}0a`, transform: "translateY(-1px)", boxShadow: `0 8px 18px -12px ${o.color}` },
                      "&:hover .lo-arrow": { color: o.color, transform: "translateX(2px)" },
                    }}
                  >
                    <Box sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", color: o.color, bgcolor: `${o.color}14` }}>
                      {o.icon}
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>{o.label}</Typography>
                      <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>{o.text}</Typography>
                    </Box>
                    <ChevronRightIcon className="lo-arrow" sx={{ color: "#cbd5e1", transition: "all .15s ease" }} />
                  </Box>
                ))}
              </Stack>
            </DialogContent>
          </Dialog>

          {/* ---------- Leave confirmation (Back) ---------- */}
          <Dialog
            open={leaveOpen}
            onClose={() => setLeaveOpen(false)}
            fullWidth
            maxWidth="xs"
            PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 400 } } }}
          >
            <DialogContent sx={{ p: 3, textAlign: "center" }}>
              <Box sx={{ width: 52, height: 52, mx: "auto", mb: 1.5, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#d97706", bgcolor: "#fef3c7" }}>
                <WarningAmberRoundedIcon />
              </Box>
              <Typography sx={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>Leave the bot flow?</Typography>
              <Typography sx={{ mt: 0.5, fontSize: 13.5, color: "#64748b" }}>
                Changes that are not submitted will be lost.
              </Typography>
              <Stack direction="row" spacing={1.25} justifyContent="center" sx={{ mt: 2.25 }}>
                <Button
                  onClick={() => setLeaveOpen(false)}
                  sx={{ height: 36, minWidth: 100, px: 2.25, fontSize: 13.5, borderRadius: 2.5, textTransform: "none", fontWeight: 700, color: "#475569", border: "1.5px solid #e2e8f0", "&:hover": { bgcolor: "#f8fafc" } }}
                >
                  Stay
                </Button>
                <Button
                  onClick={() => {
                    setLeaveOpen(false);
                    navigate(APP_ROUTES.CHATBOT.LIST);
                  }}
                  sx={{ height: 36, minWidth: 100, px: 2.25, fontSize: 13.5, borderRadius: 2.5, textTransform: "none", fontWeight: 700, color: "#fff", background: "linear-gradient(135deg, #fc8006, #fb923c)", "&:hover": { background: "linear-gradient(135deg, #ea7505, #fc8006)" } }}
                >
                  Leave
                </Button>
              </Stack>
            </DialogContent>
          </Dialog>
        </Stack>
      )}
      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />{" "}
    </div>
  );
};
export default ({ keyWordName, chatBotName }) => (
  <ReactFlowProvider>
    <Flow keyWordName={keyWordName} chatBotName={chatBotName} />
  </ReactFlowProvider>
);
